import React from "react";
import { Sparkles } from "lucide-react";
import { usePlan } from "../context/PlanContext";

export const TrialBanner = () => {
  const { data, goPlans } = usePlan();
  if (!data?.trial?.active) return null;
  const d = data.trial.days_left;
  return (
    <div className="mb-6 rounded-2xl bg-[#eefafa] border border-[#2ec9c9]/30 px-5 py-4 flex flex-wrap items-center justify-between gap-3" data-testid="trial-banner">
      <p className="text-sm text-[#16243b] flex items-center gap-2">
        <Sparkles size={16} className="text-[#2ec9c9]" />
        <span><strong data-testid="trial-days-left">{d} day{d === 1 ? "" : "s"}</strong> left of your free {data.current.name} trial — every feature is unlocked.</span>
      </p>
      <button onClick={goPlans} data-testid="trial-choose-plan" className="gp-btn-teal rounded-full px-4 py-2 text-xs font-semibold">Choose a plan</button>
    </div>
  );
};
